import { actionCreatorFactory } from 'typescript-fsa';
import { ArrowType, DesignSet, OrderType } from '@app/react/const/type';

const actionCreator = actionCreatorFactory('selectAction');

export interface IYourDesignParam {
    params: DesignSet;
    arrowType: ArrowType;
    orderType: OrderType;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IYourDesignResult {}

export interface IYourDesignError {
    message: string;
}

export const yourDesignAction = actionCreator.async<
IYourDesignParam,
IYourDesignResult,
IYourDesignError
>('yourDesign');
